export default __webpack_public_path__ + "static/media/mina2.b1580e0c.jpg";